import { connect } from "react-redux";
const OwlShopActions = require("lib/actions/OwlShopActions");
const OwlShopSelectors = require("lib/selectors/OwlShopSelectors");
var CurrentUser = require("lib/account/CurrentUser");
var Owlvatar = require("components/avatars/Owlvatar");
var OwlShopDisplay = require("components/avatars/OwlShopDisplay");
var OwlShopColorPicker = require("components/avatars/OwlShopColorPicker");
var ShopSales = require("lib/games/ShopSales");


require("avatars/owl_shop_patcher.scss");

@connect(
	(state, ownProps) => ({
		filteredPatches: OwlShopSelectors.getFilteredPatches({ state }),
		filteredPerks: OwlShopSelectors.getFilteredPerks({ state }),
		allFurnitures: OwlShopSelectors.getFurnitures({ state }),
		getPatchesByNameAndType: ({ name, originType }) =>
			OwlShopSelectors.getPatchesByNameAndType({ state, name, originType }),
		getPerksByNameAndType: ({ name, type }) =>
			OwlShopSelectors.getPerksByNameAndType({ state, name, type }),
		user: CurrentUser.get(),
	}),
	(dispatch, props) => ({
		postPatches: ({ patch, newProperties, callback }) =>
			dispatch(OwlShopActions.postPatches({ patch, newProperties, callback })),
		postPerks: ({ perk, newProperties, callback }) =>
			dispatch(OwlShopActions.postPerks({ perk, newProperties, callback })),
		//Fetch updated perks for users
		updateCurrentUser: (callback) => {CurrentUser.fetchCurrentUserData(callback)}
	}),
)
class OwlShopPatcher extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { 
			buyLoading: false, 
			isOpen: $wr.shouldShopOpen(props.user),
		};
	}

	getPatches(patchType) {
		if (this.props.mode == "dressing") {
			return _.select(this.props.filteredPatches, function(patch) {
				return patch.patch_type == patchType && patch.owned;
			});
		}

		return _.select(this.props.filteredPatches, function(patch) {
			return patch.patch_type == patchType;
		});
	}

	getPerks(perkType) {
		if (this.props.mode === "furniture") {
			return _.select(this.props.allFurnitures, function(perk) {
				return perk.perk_type == perkType;
			});
		} else {
			return _.select(this.props.filteredPerks, function(perk) {
				return perk.perk_type == perkType;
			});
		}
	}

	selectColor(colorIndex, patchType) {
		var newColors = _.clone(this.props.colors);
		newColors[patchType] = colorIndex;
		this.props.setColors(newColors);

		// Mycroft.newEvent({ category: "Owl Shop", action: "select-color", label: ("color" + colorIndex) });
	}

	selectItem(item, equipType) {
		if (item.patch_type) {
			if (item.owned) {
				var newEquippedPatches = _.clone(this.props.equippedPatches);
				newEquippedPatches[equipType] = item;
				this.props.setEquippedPatches(newEquippedPatches);
			}
		} else if (item.perk_type == "backgrounds") {
			$(".patcher").addClass("backgroundPatcher");
			$wr.displayBackground(item.name);
		}
		this.props.setPreviewItem(item.name, equipType);
	}

	removeItem(item, equipPatchType) {
		if (!item || !equipPatchType) {
			return;
		}
		if (item.patch_type) {
			if (item.owned) {
				var newEquippedPatches = _.clone(this.props.equippedPatches);

				var isRequiredPatchType = _.include(
					REQUIRED_PATCH_TYPES,
					equipPatchType,
				);
				if (isRequiredPatchType) {
					newEquippedPatches[equipPatchType] = _.find(
						this.getPatches(equipPatchType),
						function(patch) {
							return patch.source == "default";
						},
					);
				} else {
					newEquippedPatches[equipPatchType] = Owlvatar.NO_PATCH;
				}
				var text = "Magic! You removed an accessory from your owl!";
				window.wrNotifications.triggerDropDownNotification({
					title: "Patch removed",
					text: text,
					icon: "ok-sign",
				});
				this.props.setEquippedPatches(newEquippedPatches);
			}
			this.props.setPreviewItem(null, null);
		} else {
			this.props.postPerks({
				perk: { ...item  },
				newProperties: {equipped: false},
				callback: this.handlePerkRemovePostResponse(equipPatchType),
			});
		}
	}

	getPreviewItem() {
		if (this.props.activePatchType) {
			return _.find(
				this.props.filteredPatches,
				function(patch) {
					return (
						patch.name == this.props.previewItemName &&
						patch.patch_type == this.props.activePatchType
					);
				}.bind(this),
			);
		} else {
			return _.find(
				this.props.filteredPerks,
				function(perk) {
					return (
						perk.name == this.props.previewItemName &&
						perk.perk_type == this.props.activeOtherType
					);
				}.bind(this),
			);
		}
	}

	notifyErrors = errors =>
		window.wrNotifications.triggerDropDownNotification({
			title: "Sorry!",
			text: errors.join(", "),
			icon: "exclamation-sign",
			type: "error",
		});

	notifyPatchBought = patch =>
		window.wrNotifications.triggerDropDownNotification({
			title: "Looking good!",
			text: "You bought " + patch.title,
			icon: "ok-sign",
		});

	notifyPatchUpgraded = patch =>
		window.wrNotifications.triggerDropDownNotification({
			title: "Looking good!",
			text: "You upgraded " + patch.title,
			icon: "ok-sign",
		});

	isPatchUpgrade = patch => !!patch.has_animation;

	isPatch = item => !!item.patch_type;

	handlePatchPostResponse = itemType => response => {
		const { patch } = response;

		if (patch.errors) {
			this.notifyErrors(patch.errors);
			this.setState({
				buyLoading: false,
			});
		} else {
			if (this.isPatchUpgrade(patch)) {
				this.notifyPatchUpgraded(patch);
			} else {
				this.notifyPatchBought(patch);
			}
			
			//if a hand item is purchased, we need to make sure the 
			//corresponding left/right item is owned and visually updates
			//accordingly
			if (patch.origin_patch_type == "hand"){
				this.props.fetchPatches()
			} 
			this.props.updateCurrentUser(f=>f);

			this.setState({ buyLoading: false }, () =>
				this.selectItem(patch, itemType)
			);

			Mycroft.newEvent({
				category: "Owl Shop",
				action: "buy-item",
				label: patch.title,
			});
		}
	};

	isOwned = item => !!item.owned;

	getPerkNotificationText = perk => {
		if (this.isOwned(perk)) {
			if (perk.perk_type == BACKGROUNDS) {
				return "Your wallpaper has been saved!";
			} else if (perk.perk_type == TITLES) {
				return "Your title has been saved!";
			}
		} else {
			return "You bought " + perk.name;
		}
	};

	notifyPerkChange = perk =>
		window.wrNotifications.triggerDropDownNotification({
			title: "Looking good!",
			text: this.getPerkNotificationText(perk),
			icon: "ok-sign",
		});

	handlePerkPostResponse = itemType => response => {
		const { perk } = response;

		if (perk.errors) {
			this.notifyErrors(perk.errors);
			this.setState({
				buyLoading: false,
			});
		} else {
			this.notifyPerkChange(perk);

			this.props.updateCurrentUser(f=>f);

			this.setState({ buyLoading: false }, () =>
				this.selectItem(perk, itemType)
			);

			this.props.fetchPerks();

			Mycroft.newEvent({
				category: "Owl Shop",
				action: "buy-item",
				label: perk.name,
			});
		}
	};

	getPerkRemovalMessage = perk => {
		if (perk.perk_type == BACKGROUNDS) {
			$(".OwlShopPatcher").removeClass("hasBackground");
			$(".patcher").removeClass("backgroundPatcher");
			$wr.removeBackground();
			return {
				text: "Poof! Your wallpaper has disappeared!",
				title: "Wallpaper removed",
			};
		} else if (perk.perk_type == TITLES) {
			return { title: "Title removed", text: "Poof! your title has vanished!" };
		} else if (perk.perk_type == BACKGROUND_SOUNDS) {
			return {
				title: "Background Tune removed",
				text: "Poof! your background tune has vanished!",
			};
		} else if (perk.perk_type == HOUSES) {
			return { title: "House removed", text: "Poof! your house has vanished!" };
		} else if (perk.perk_type == OWL_HOOTS) {
			return {
				title: "Owl hoot removed",
				text: "Poof! your owl's hoot has vanished!",
			};
		} else if (perk.perk_type == GREETINGS) {
			return {
				title: "Greeting animation removed",
				text: "Poof! your greeting animation has vanished!",
			};
		}
	};

	notifyPerkRemoval = ({ title, text }) =>
		window.wrNotifications.triggerDropDownNotification({
			title: title,
			text: text,
			icon: "ok-sign",
		});

	handlePerkRemovePostResponse = itemType => response => {
		
		const { perk } = response;
		if (perk.errors) {
			this.notifyErrors(perk.errors);
			this.setState({
				buyLoading: false,
			});
		} else {
			const newProperties = { owned: true };

			this.notifyPerkRemoval(this.getPerkRemovalMessage(perk));
			
			this.props.setPreviewItem(null, null);

			this.props.updateCurrentUser(() => {this.forceUpdate()});

			this.props.fetchPerks();

			this.setState({ buyLoading: false })
		}
	};

	purchaseItem(item, equipPatchType) {
		this.setState({ buyLoading: true });

		if (this.isPatch(item)) {
			this.props.postPatches({
				patch: item,
				newProperties: null,
				callback: this.handlePatchPostResponse(equipPatchType),
			});
		} else {
			this.props.postPerks({
				perk: item,
				newProperties: null,
				callback: this.handlePerkPostResponse(equipPatchType),
			});
		}
	}

	previewAnimation(name) {
		this.props.previewAnimation(name)
	}

	buildItemTypeSelectF(patchType, otherType) {
		return function(e) {
			if (e) {
				e.preventDefault();
			}
			this.props.setActiveType(patchType, otherType);
			this.props.setPreviewItem(null, null);
			Mycroft.newEvent({
				category: "Owl Shop",
				action: "select-category",
				label: patchType || otherType,
			});
		}.bind(this);
	}

	// to keep category selector highlighted correctly in hand and body special cases
	isActivePatchType(patchType) {
		var activePatchType = this.props.activePatchType;
		if (
			activePatchType == "left_hand" ||
			activePatchType == "hand" ||
			activePatchType == "wings"
		) {
			return patchType == "left_hand";
		} else if (activePatchType == "body" || activePatchType == "body2") {
			return patchType == "body";
		} else {
			return patchType == activePatchType;
		}
	}

	renderCategorySelector(text, patchType, otherType) {
		if (patchType) {
			var onClick = this.buildItemTypeSelectF(patchType, null);
		} else {
			var onClick = this.buildItemTypeSelectF(null, otherType);
		}
		if (this.props.activePatchType && this.isActivePatchType(patchType)) {
			var categoryClass = "selector selectedPatchType";
		} else {
			if (this.props.activeOtherType && this.props.activeOtherType == otherType) {
				var categoryClass = "selector selectedPatchType";
			} else {
				var categoryClass = "selector";
			}
		}

		return (
			<a href="#" className={categoryClass} onClick={onClick}>
				<img src={dynamicRequire("owl-item-types/" + (patchType || otherType) + ".png")} />
				<span className="categoryTitle">{text}</span>
			</a>
		);
	}

	renderOwlShopModeSelectors() {
		if (!this.props.hideOwls) {
			var owlCustomizers = (
				<div>
					{this.renderCategorySelector("Head", "head", null)}
					{this.renderCategorySelector("Face", "face", null)}
					{this.renderCategorySelector("Eyes", "eyes", null)}
					{this.renderCategorySelector("Beak", "beak", null)}
					{this.renderCategorySelector("Body", "body", null)}
					{this.renderCategorySelector("Wings", "left_hand", null)}
					{this.renderCategorySelector("Feet", "feet", null)}
				</div>
			);
			var hoots = this.renderCategorySelector("Hoots", null, "owl_hoots");
			var greetings = this.renderCategorySelector("Greetings", null, "greetings");
		}
		return (
			<div className="categorySection">
				<div className="modeSelectorRowContainer">
					<span className="sectionTitle"> Change Your Look </span>
					{owlCustomizers}
				</div>
				<div className="modeSelectorRowContainer">
					<span className="sectionTitle"> Get Yourself A Perk </span>
					<div>
						{this.renderCategorySelector("Titles", null, "titles")}
						{this.renderCategorySelector("Wallpapers", null, "backgrounds")}
						{greetings}
						{hoots}
						{this.renderCategorySelector("Tunes", null, "background_sounds")}
						{this.renderCategorySelector("Houses", null, "houses")}
					</div>
				</div>
			</div>
		);
	}

	renderDressingModeSelectors() {
		if (!this.props.hideOwls) {
			var owlCustomizers = (
				<div>
					{this.renderCategorySelector("Head", "head", null)}
					{this.renderCategorySelector("Face", "face", null)}
					{this.renderCategorySelector("Eyes", "eyes", null)}
					{this.renderCategorySelector("Beak", "beak", null)}
					{this.renderCategorySelector("Body", "body", null)}
					{this.renderCategorySelector("Wings", "left_hand", null)}
					{this.renderCategorySelector("Feet", "feet", null)}
				</div>
			);
		}
		return (
			<div className="categorySection">
				<div className="modeSelectorRowContainer dressingSelectors">
					<span className="sectionTitle"> Owned Items! </span>
					{owlCustomizers}
				</div>
			</div>
		);
	}

	renderFurnitureModeSelectors() {
		return (
			<div className="categorySection">
				<div>
					{this.renderCategorySelector("Wall Items", null, "wall_items")}
					{this.renderCategorySelector("Bookshelves", null, "bookshelves")}
					{this.renderCategorySelector("Sofas", null, "sofas")}
					{this.renderCategorySelector("Floor Items", null, "floor_items")}
				</div>
			</div>
		);
	}
	renderAllCategorySelectors() {
		if (this.props.mode == "furniture") {
			var selectors = this.renderFurnitureModeSelectors();
		} else if (this.props.mode == "dressing") {
			var selectors = this.renderDressingModeSelectors();
		} else {
			var selectors = this.renderOwlShopModeSelectors();
		}
		return <div className="categorySelector clearfix">{selectors}</div>;
	}

	renderDisplay() {
		var type = this.props.activePatchType || this.props.activeOtherType;
		if (this.props.activeOtherType) {
			var items = this.getPerks(this.props.activeOtherType);
		} else {
			var items = this.getPatches(this.props.activePatchType);
		}

		var items = _.sortBy(items, function(item) {
			if (item.patch_type) {
				var onSale = ShopSales.isOnSale(item.origin_patch_type, item.name) ? "0sale" : "1sale";
			} else {
				onSale = "1sale";
			}
			var tier = item.tier || 0;
			var price = item.price || 0;
			return onSale + " " + tier + " " + price;
		});

		var beginAtTier = this.props.beginAtTier

		var display = (
			<OwlShopDisplay
				mode={this.props.mode}
				key={type}
				user={this.props.user}
				itemType={type}
				items={items}
				previewItem={this.getPreviewItem()}
				loading={this.state.buyLoading}
				buildItemTypeSelectF={this.buildItemTypeSelectF}
				selectItem={this.selectItem}
				purchaseItem={this.purchaseItem}
				previewAnimation={this.previewAnimation}
				removeItem={this.removeItem}
				isPatch={!this.props.activeOtherType}
				beginAtTier={beginAtTier}
			/>
		);
		return display;
	}

	renderColorPickers() {
		var pickers = [];

		switch (this.props.activePatchType) {
			case "hand":
			case "left_hand":
			case "wings":
				pickers.push(
					<OwlShopColorPicker
						key="wings"
						currentColor={this.props.colors["wings"]}
						patchType={"wings"}
						selectColor={this.selectColor}
					/>,
				);
				break;
			case "body":
			case "body2":
				pickers.push(
					<OwlShopColorPicker
						key="base"
						currentColor={this.props.colors["base"]}
						patchType={"base"}
						selectColor={this.selectColor}
					/>,
				);

				pickers.push(
					<OwlShopColorPicker
						key="stomach"
						currentColor={this.props.colors["stomach"]}
						patchType={"stomach"}
						selectColor={this.selectColor}
					/>,
				);
				break;
			case "face":
				pickers.push(
					<OwlShopColorPicker
						key="eyes"
						currentColor={this.props.colors["eyes"]}
						patchType={"eyes"}
						selectColor={this.selectColor}
					/>,
				);
				break;
		}

		return <div className="colorPickers">{pickers}</div>;
	}

	renderShopCurtain() {
		var openingTime = $wr.getShopOpeningTime(this.props.user);
		var src = require("tiers/lock.png");
		var patchImg = <img src={src} className="lockImg" />;
		if (openingTime != "Never") {
			var openingDetails = "It will open today at " + openingTime;
		}
		return (
			<div className="curtain">
				<div>{patchImg}</div>
				<p>
					Your teacher has closed the Owl Shop. <br />
					{openingDetails}
				</p>
			</div>
		);
	}

	render() {
		var shopClass = "";
		if (!this.state.isOpen) {
			shopClass = "closedShop";
			var curtain = this.renderShopCurtain();
		}

		if (this.props.mode != "dressing") {
			var colorPickers = this.renderColorPickers()
		} else {
			var displayClass = "dressingDisplay"
		}

		return (
			<div className="OwlShopPatcher">
				{curtain}
				<div className={shopClass}>
					{this.renderAllCategorySelectors()}
					<div className = { displayClass }>
						{this.renderDisplay()}
					</div>
					{colorPickers}
				</div>
			</div>
		);
	}

	onScroll() {
		var $preview = $(this.refs.preview);

		$preview.removeClass("fixed");
		$preview.removeClass("absolute");
		$preview.css("top", "55px");
		var scrollTop = $(window).scrollTop();
		var previewOffset = $preview.offset().top;
		var minDistance = 40;

		var footerOffset = $(".siteFooter").offset().top;
		var previewHeight = $preview.height() + 50;
		var docHeight = $(document).height();
		var winHeight = $(window).height();

		if (scrollTop + previewHeight > footerOffset) {
			var top = footerOffset - previewHeight - 110;
			$preview.addClass("absolute");
			$preview.css("top", top + "px");
		} else if (previewOffset - minDistance < scrollTop) {
			$preview.addClass("fixed");
		}
	}

	componentWillUnmount() {
		$(window).off("scroll", this.onScroll);
		// prevent background from being removed when closing house modal
		if (this.props.mode == "owl_shop") {
			$wr.removeBackground();
		}
	}
}

// OwlShopPatcher.propTypes = PageStrictPropTypes({
// });


//OwlShopPatcher.REQUIRED_PATCH_TYPES = ["feet", "eyes", "wings", "beak"];
var REQUIRED_PATCH_TYPES = ["feet", "eyes", "wings", "beak"];
var BACKGROUNDS = "backgrounds";
var TITLES = "titles";
var HOUSES = "houses";
var GREETINGS = "greetings";
var OWL_HOOTS = "owl_hoots";
var BACKGROUND_SOUNDS = "background_sounds";

module.exports = OwlShopPatcher;



// WEBPACK FOOTER //
// ./modules/components/avatars/OwlShopPatcher.js